import Reveal from "@/components/base/Reveal";
import SectionHeading from "@/components/base/SectionHeading";
import { successCases } from "@/mocks/siteData";

export default function SuccessSection() {
  return (
    <section id="success" className="bg-background-50 py-20 md:py-28">
      <div className="mx-auto w-full max-w-6xl px-4 md:px-6">
        <Reveal>
          <SectionHeading
            kicker="Success Cases"
            title="성공사례"
            description={
              <>
                실제 진행 사례를 각색·비실명 처리했습니다.
                <br />
                결과는 개별 사건에 따라 달라질 수 있습니다.
              </>
            }
          />
        </Reveal>

        <div className="mt-12 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {successCases.map((item, i) => (
            <Reveal key={item.title} delay={(i % 3) * 80}>
              <article className="flex h-full flex-col rounded-lg border border-background-200/70 bg-background-100/50 p-6 transition-colors duration-300 hover:border-primary-700/50">
                <span className="inline-flex w-fit items-center rounded-full border border-primary-800/50 bg-primary-950/40 px-3 py-1 text-xs text-primary-400">
                  {item.tag}
                </span>
                <h3 className="font-subheading mt-4 text-lg font-semibold text-foreground-950">
                  {item.title}
                </h3>

                <div className="mt-4 flex items-center gap-3 rounded-md bg-background-50/80 px-4 py-3">
                  <div className="min-w-0 flex-1">
                    <div className="text-xs text-foreground-500">채무</div>
                    <div className="mt-0.5 truncate text-sm font-medium text-foreground-900">
                      {item.debt}
                    </div>
                  </div>
                  <i className="ri-arrow-right-line shrink-0 text-accent-400" />
                  <div className="min-w-0 flex-1 text-right">
                    <div className="text-xs text-foreground-500">결과</div>
                    <div className="mt-0.5 text-sm font-medium text-primary-400">
                      {item.result}
                    </div>
                  </div>
                </div>

                <div className="mt-3 flex flex-wrap gap-x-4 gap-y-1 text-xs text-foreground-500">
                  <span>
                    관할 <b className="font-medium text-foreground-700">{item.court}</b>
                  </span>
                  <span>
                    진행 <b className="font-medium text-foreground-700">{item.period}</b>
                  </span>
                </div>

                <p className="mt-4 flex-1 text-sm leading-relaxed text-foreground-600">
                  {item.desc}
                </p>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}